import { render, staticRenderFns } from "./ShowSetPrice_deactive.vue?vue&type=template&id=54320d34&scoped=true"
import script from "./ShowSetPrice_deactive.vue?vue&type=script&lang=js"
export * from "./ShowSetPrice_deactive.vue?vue&type=script&lang=js"
import style0 from "./ShowSetPrice_deactive.vue?vue&type=style&index=0&id=54320d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54320d34",
  null
  
)

export default component.exports